import React from "react"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import MAppComponent from "../capp-component";
import {Link} from "react-router-dom";
import ContentUnitIcon from "../../../../common/js/components/content-units/content-unit-icon";

class ContentUnitListItem extends MAppComponent {

    badge() {
        let color = 'white';

        switch (this.props.assignment.state) {
            case 'complete':
                color = 'gasnet-green';
                break;

            case 'submitted':
                color = 'gray';
                break;

            case 'rejected':
                color = 'red';
                break;
        }

        return (
            <span className={`badge badge-pill badge-${ color }`}><FormattedMessage id={`app.content_units.attribute.state.${this.props.assignment.state}`}/></span>
        )
    }

    button() {
        let contentUnit = this.props.assignment.content_unit;
        let color = 'gasnet-green';
        let text = this.props.intl.formatMessage({id: 'app.content_units.buttons.read'});

        switch (this.props.assignment.content_unit.type) {
            case 'ContentUnits::PersonalForm':
                switch (this.props.assignment.state) {
                    case 'complete':
                        color = 'gray';
                        text = this.props.intl.formatMessage({id: 'app.content_units.buttons.fill_in'});
                        break;

                    default:
                        text = this.props.intl.formatMessage({id: 'app.content_units.buttons.fill_in'});
                        break;
                }
                break;
                
            case 'ContentUnits::MedicalExamUpload':
            case 'ContentUnits::EducationProofUpload':
                switch (this.props.assignment.state) {
                    case 'complete':
                        color = 'gray';
                        text = this.props.intl.formatMessage({id: 'app.content_units.buttons.review'});
                        break;

                    case 'submitted':
                        color = 'gray';
                        text = this.props.intl.formatMessage({id: 'app.content_units.buttons.review'});
                        break;

                    case 'rejected':
                        color = 'gasnet-green';
                        text = this.props.intl.formatMessage({id: 'app.content_units.buttons.resubmit'});
                        break;

                    default:
                        text = this.props.intl.formatMessage({id: 'app.content_units.buttons.submit'});
                        break;
                }
                break;

            default:
                switch (this.props.assignment.state) {
                    case 'complete':
                        color = 'gray';
                        text = this.props.intl.formatMessage({id: 'app.content_units.buttons.read_again'});
                        break;
                }
        }

        switch (contentUnit.category) {
            case "important_document":
                return (<Link to={`/important-documents/${this.props.assignment.id}`} className={`btn btn-${ color }`}>{ text }</Link>);

            case "life_at_innogy":
                return (<Link to={`/life-at-innogy/${this.props.assignment.id}`} className={`btn btn-${ color }`}>{ text }</Link>);
        }
    }

    render() {
        const { assignment } = this.props;

        return (
            <div className={`card content-unit-card bg-${( this.props.color || 'white' )} se-sm`}>
                <div className='card-body content-unit-card__content'>
                    <ContentUnitIcon contentUnit={assignment.content_unit} className='content-unit-card__image'/>
                    <h3><span className='content-unit-card__content__title'>{ assignment.content_unit.title }</span>{ assignment.state && this.badge() }
                    </h3>
                    <p>{ assignment.content_unit.description }</p>
                </div>
                <div className='card-body content-unit-card__details pl-1'>
                    { assignment.content_unit.estimated_time &&
                    <div className='content-unit-card__details__estimate'>
                        <div className='pb-2'><small><FormattedMessage id='app.content_units.attribute.estimated_time'/></small></div>
                        <div>{ assignment.content_unit.estimated_time } min</div>
                    </div>
                    }
                    { this.button() }
                </div>
            </div>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
        assignment: ownProps.assignment
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, matchDispatchToProps)(ContentUnitListItem));
